$('#fp-slider').owlCarousel({
    loop:true,
    margin:20,
    stagePadding:100,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            margin:16
        },
        576:{
            items:2,
            margin:16,
            stagePadding:60
        },
        768:{
            items:2,
            margin:20
        },
        992:{
            items:3,
            margin:20
        },
    }
})

$('#up-to-slider').owlCarousel({
    loop:true,
    margin:20,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1
        },
    }
})

/* New Arrivals Slider */
function initNewArrivalsSlider() {
    var $slider = $('#new-arrivals-slider');
    var itemsCount = $slider.find('.item').length;

    // Destroy if already initialized
    if ($slider.hasClass('owl-loaded')) {
        $slider.trigger('destroy.owl.carousel');
        $slider.removeClass('owl-loaded');
        $slider.find('.owl-stage-outer').children().unwrap();
    }

    let w = window.innerWidth;

    if (w >= 992) {
        if (itemsCount === 3) {
            $slider.owlCarousel({
                items: 3,
                margin: 30,
                loop: false,
                autoplay: false,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                dots: false,
                nav: false
            });
        } 
        else {
            $slider.owlCarousel({
                loop: true,
                margin: 30,
                autoplay: true,
                autoplayTimeout: 3000,
                dots: false,
                nav: false,
                responsive: {
                    992: { items: 3 }
                }
            });
        }
    } else {
        $slider.owlCarousel({
            loop: true,
            margin: 20,
            autoplay: true,
            autoplayTimeout: 3000,
            dots: false,
            nav: false,
            responsive: {
                0:{ items:1, stagePadding:100, margin:16 },
                576:{ items:2, stagePadding:80, margin:16 },
                768:{ items:2, stagePadding:100, margin:20 }
            }
        });
    }
}

// INIT BOTH SLIDERS
initNewArrivalsSlider();

// RESIZE
$(window).on('resize', function () {
    initNewArrivalsSlider();
});

$('#reviews-slider').owlCarousel({
    loop:true,
    margin:30,
    nav: false,
    dots: true,
    responsiveClass:true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1,
            margin:15
        },
        768:{
            items:2,
            margin:20
        },
        992:{
            items:2,
            margin:30
        },
    }
})